import { Observable, Subject } from 'rxjs';

export class ModalBottomSheetRef<TResult = unknown> {
  private readonly dismissedSubject = new Subject<TResult | undefined>();

  readonly afterDismissed: Observable<TResult | undefined> =
    this.dismissedSubject.asObservable();

  constructor(private readonly closeSheet: (result?: TResult) => void) {}

  dismiss(result?: TResult): void {
    this.closeSheet(result);
  }

  handleDismissed(result?: TResult): void {
    this.dismissedSubject.next(result);
    this.dismissedSubject.complete();
  }
}
